export type Ratio = "16/9" | "5/6" | "4/3" | "2/1" | "3/2" | "1/1" | "490/400" | "310/260" | "496/280" | "496/540";

/**
 * Parse a ratio into its width and height components.
 *
 * @param ratio The ratio.
 * @returns A tuple containing the width and height of the ratio.
 */
export function parseRatio(ratio?: Ratio): [number, number] | undefined {
  if (!ratio) {
    return;
  }
  const [width, height] = ratio.split("/");
  if (width && height) {
    return [Number(width), Number(height)];
  }
}

/**
 * Resize the dimensions of an element by maintaining the aspect ratio.
 *
 * @param width The current width of the element.
 * @param height The current height of the element.
 * @param ratio The desired aspect ratio after resizing.
 * @returns A tuple containing the new width and height
 */
export function resizeByRatio(width: number, height: number, ratio?: [number, number]): [number, number] {
  const currentAspectRatio = width / height;
  const newAspectRatio = ratio ? ratio[0] / ratio[1] : currentAspectRatio;
  if (currentAspectRatio === newAspectRatio) {
    return [width, height];
  }
  if (currentAspectRatio < newAspectRatio) {
    return [width, Math.round(width / newAspectRatio)];
  }
  return [Math.round(height * newAspectRatio), height];
}